//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'SurveyQuestions',

  props: {
    questions: {
      type: Array,
      default: () => [],
    },
    answers: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    answersValue() {
      const answersValue = {}

      this.questions.forEach((question) => {
        const questionAnswer = this.answers.find(
          (answer) => answer?.id === question.id
        )

        if (questionAnswer) {
          answersValue[question.id] = questionAnswer.options.map(
            (option) => option.id
          )
        } else {
          answersValue[question.id] = []
        }
      })

      return answersValue
    },
  },

  methods: {
    doSelect(questionId, selectedOptions) {
      const questionIndex = this.questions.findIndex(
        (question) => question.id === questionId
      )
      const question = this.questions[questionIndex]

      const newAnswers = [...this.answers]

      newAnswers[questionIndex] = {
        id: question.id,
        title: question.title,
        options: selectedOptions.map((option) => ({
          id: option.id,
          title: option.title,
        })),
      }
      this.$emit('update:answers', newAnswers)
    },
  },
}
